// extracted by mini-css-extract-plugin
export default {"alert":"styles_alert__WIlh4"};